// extracted by mini-css-extract-plugin
export default {"updateNotification":"app-react-sidebar-Footer-UpdateNotifications-module__update-notification"};